<div class="flex items-center">
    <div mat-dialog-title class="!text-base">
        <span class="text-adp-primary-500 font-bold">Selecciona una empresa</span>
    </div>
    <span class="flex-1"></span>
    <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="pb-0 mb-0">
  <ng-container *ngIf="filteredTenants?.length > 0; else loading">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Empresa</mat-label>
      <mat-select [(value)]="selectedTenant">
        <ngx-mat-select-search [formControl]="tenantSearchCtrl" placeholderLabel="Buscar empresa" noEntriesFoundLabel="Sin resultados"></ngx-mat-select-search>
        <mat-option *ngFor="let tenant of filteredTenants" [value]="tenant.slug">
          <div class="flex items-center gap-2">
            <img
              *ngIf="tenant.logo"
              [src]="tenant.logoEscudoExists? tenant.logoEscudoPath : 'assets/images/noimage.png'"
              alt="{{ tenant.name }}"
              width="24"
              height="24"
            />
            {{ tenant.name }}
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>

  <ng-template #loading>
    <div class="flex justify-center p-4">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="center" class="modal-actions">
  <button
    type="submit"
    mat-raised-button
    color="primary"
    [disabled]="!selectedTenant"
    (click)="confirm()"
  >
    Ingresar
  </button>
</mat-dialog-actions>
